import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { EuiToolTip } from "@elastic/eui";
import { ReactComponent as RejectionMarker } from "assets/icons/rejection.svg";

const GlobalStyle = createGlobalStyle`
  .rejection-tooltip {
    background-color: #fff !important;
  }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    padding-bottom: 10px;
    background-color: #f8e9e9;
    border-radius: 12px;
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;
`;

const Title = styled.h3`
    font-size: 14px;
    font-weight: 700;
    color: #6b7280;
    border-bottom: 1px solid #d1d5db;
    padding: 3px 0;
`;

const BodyContent = styled.p`
    font-weight: 400;
    font-size: 14px;
    color: #000405;
    padding: 3px 0;
    text-align: left;
    white-space: pre-line;
`;

const RejectionBody = (content) => (
    <Body>
        <Title>Rejection Reason</Title>
        <BodyContent>{content}</BodyContent>
    </Body>
);

const RejectionReason = ({ content }) => (
    <>
        <GlobalStyle />
        <EuiToolTip
            position="top"
            content={RejectionBody(content)}
            repositionOnScroll
            className="rejection-tooltip"
        >
            <Container>
                <RejectionMarker />
            </Container>
        </EuiToolTip>
    </>
);

export default RejectionReason;
